import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, of, switchMap } from 'rxjs';
import { CompositeId, ProfileRepository } from '@capital-access/profiles/common';
import {
  mapContactInformationDtoToContactSuggesterItem,
  mapListsToContactSuggesterItem
} from '../../utils/contacts.utils';
import { addToNewEmail, composeNewEmail } from './actions';

@Injectable()
export class EmailsSharedEffects {
  addToEmail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addToNewEmail),
      switchMap(({ contacts, contactLists }) => {
        const recipients = (contactLists ?? []).map(list => mapListsToContactSuggesterItem(list));

        if (!contacts || contacts.length === 0) {
          return of(composeNewEmail({ recipients }));
        }

        return this.profileRepository
          .getContactsInformation(
            contacts.map(contactIds => new CompositeId(contactIds.prId, contactIds.crmId)),
            ['id', 'name', 'contacts']
          )
          .pipe(
            map(contactsInfo => {
              const contactItems = contactsInfo.map(contact => mapContactInformationDtoToContactSuggesterItem(contact));

              return composeNewEmail({ recipients: [...recipients, ...contactItems] });
            })
          );
      })
    )
  );

  composeNewEmail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(composeNewEmail),
        map(() => this.router.navigate(['/emails/create']))
      ),
    { dispatch: false }
  );

  constructor(private actions$: Actions, private router: Router, private profileRepository: ProfileRepository) {}
}
